import { jArticleExtendViewSchema, jArticleListSchema } from './article';
import { z } from 'zod';

export const jSocialEventListSchema = jArticleListSchema.extend({
    place: z.string(),
    address: z.string(),
    dateStart: z.string(),
    dateEnd: z.string(),
    noGestion: z.boolean(),
    allDay: z.boolean(),
    textColor: z.string(),
    backgroundColor: z.string(),
});
export type jSocialEventList = z.infer<typeof jSocialEventListSchema>;

export const ensureIsSocialEventList = (o: unknown): o is jSocialEventList => {
    return jSocialEventListSchema.safeParse(o).success;
};

export const jSocialEventViewSchema = jArticleExtendViewSchema.merge(jSocialEventListSchema).merge(
    z.object({
        allDay: z.boolean(),
        useQrcode: z.boolean(),
        textColor: z.string(),
        bgColor: z.string(),
        socialEventUseCeiling: z.boolean(),
        socialEventCeiling: z.number().nullable(),
        hideFromCalendar: z.boolean(),
        urlGestion: z.string().optional().nullable(),
        webinarUrlForGuests: z.string().optional().nullable(),
    }),
);

export type jSocialEventView = z.infer<typeof jSocialEventViewSchema>;

export const validateIsFormatSocialEvent = (object: object): object is jSocialEventView => {
    return jSocialEventViewSchema.safeParse(object).success;
};
